export const esAnioBisiesto = (anio: number) => {
    return (anio % 4 === 0 && anio % 100 !== 0) || anio % 400 === 0;
};